import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import foto from "../../../assets/blog/Abril-21-2026.jpg";


const Semana57: React.FC = () => {
  const Notice1 = `
El proyecto radicado por el concejal Rodrigo Salazar para impulsar la movilidad sostenible

Ante el Concejo Distrital de Santiago de Cali,  Rodrigo Salazar, concejal del Partido Alianza Verde, radicó el proyecto de acuerdo “Cali En Bici”, una iniciativa que busca promover la movilidad sostenible y consolidar a la bicicleta como un medio de transporte seguro, digno y prioritario, que aporte a mejorar las condiciones de vida de los caleños y reducir las fatalidades en accidentes de tránsito.

“Este proyecto no nace desde un escritorio, es el resultado de un proceso de construcción participativa en el que han convergido colectivos de biciusuarios, académicos, urbanistas y actores comprometidos con una ciudad más equitativa y sostenible. Sus aportes han permitido estructurar una propuesta técnica, pero también profundamente política: defender el derecho a la ciudad y a una movilidad que ponga en el centro la vida”, manifestó el cabildante. 

Cali actualmente tiene 165 kilómetros de ciclorrutas, pero menos del 40% son realmente seguras y segregadas y en muchos casos son tramos que no se conectan entre sí, además el 5.4% de sus habitantes se moviliza por medio de la cicla, realizándose alrededor de 120 mil viajes diarios que representa apenas entre el 3% y el 5% de los viajes totales, cuando el potencial técnico de la ciudad supera el 10%.

Para Fredy Bustos, activista por el uso de la bicicleta todo las agendas que han involucrado el fomento al uso de la cicla se ha quedado relegado por los gobiernos.

“Lo que ha pasado con la bicicleta es que siempre se ata a temas de popularidad y cuando eso ocurre las agendas que son técnicas que tienen que ver con transformar ciudad pues se van dejando de lado, generando como consecuencia más caos en las vías, por eso, este proyecto en el que participamos será un instrumento más que reforzará políticas e instrumentos gubernamentales acordes a una movilidad sostenible”, expresó el activista.

Para Daniel Moreno, integrante de BiciLab Cali, cada vez es mayor la cantidad de gente que hace uso de la cicla, no solo en lo recreativo sino en ámbitos urbanos pero con una administración distrital que no está respondiendo con las expectativas de todos los biciusuarios y donde aún persisten muchas barreras.

“Reconocemos que el concejal Rodrigo Salazar se tomó el trabajo de escuchar a las demandas de la ciudadanía y de construir un proyecto que le apunta a promover la bicicleta en diferentes enfoques como infraestructura, campañas, seguimientos y que exista un a trazabilidad y herramientas que le permitan a la gente hacer una veeduría”, dijo Daniel Moreno.
 
La radicación de este proyecto, también es un acto de reparación simbólica con las familias de ciclistas víctimas de accidentes fatales, que anualmente son entre 15 y 25 sumado a los más de 400 que resultan lesionadas en siniestros viales, según el informe anual de siniestralidad vial de la Secretaría de Movilidad, estos datos reflejan que el modelo actual no es suficiente.

“Cada vida perdida en las vías es una deuda colectiva que obliga a transformar el modelo de movilidad hacia uno más seguro, humano y responsable, nuestro proyecto Cali en Bici, es una apuesta para que la bicicleta deje de ser marginal y pase a ser protagonista de la movilidad en Cali”, expresó el concejal Salazar.

“Cali En Bici” plantea una transformación integral de la movilidad urbana, con beneficios concretos para toda la ciudad:

Más infraestructura segura: priorización de ciclorrutas en corredores estratégicos (educativos, laborales y de integración con el transporte público) y obligación de incluir infraestructura ciclística en nuevas vías.

Biciparqueaderos en toda la ciudad: estándares mínimos en edificios públicos, instituciones educativas, hospitales, escenarios deportivos y parqueaderos públicos y privados.

Incentivos reales al uso de la bicicleta: reconocimiento y beneficios laborales para funcionarios públicos que se movilicen en bici.

Educación y cultura vial: inclusión de contenidos de movilidad sostenible en el sistema educativo y campañas para el respeto al ciclista.

Integración con el transporte público: articulación con el sistema MIO mediante biciparqueaderos, estudios para transporte de bicicletas en buses y sistemas públicos de préstamo.

Gestión basada en evidencia: fortalecimiento del Observatorio de Movilidad Sostenible para medir avances y orientar políticas públicas.

Participación ciudadana: conformación del Consejo Distrital de la Bicicleta como instancia de gobernanza con colectivos, academia y la institucionalidad.

Además de mejorar la seguridad vial, el proyecto representa beneficios ambientales, al reducir emisiones contaminantes; recuperación del espacio público, al disminuir la presión del vehículo particular; y mayor eficiencia en la movilidad, al diversificar los modos de transporte y descongestionar la ciudad.

#CaliEnBici es más que un proyecto de movilidad: es una apuesta por una ciudad más justa, donde moverse no sea un riesgo sino un derecho, y donde la calle vuelva a ser un espacio para la vida.
`;

  return (
    <section className={style.Noticia}>
      <div className={style.FotoMediosMarzo2025}>
        <img
          className={style.FotoImgMedios}
          src={foto}
          alt="FotoResumen"
          draggable={false}
        />
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          Menos carros, más vida:“Cali En Bici”{" "}
        </h1>
        <h5 className={style.Fecha}>Abril 21 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
